/* eslint-disable */
import $ from 'jquery';
import { DataLayer_form } from './DataLayer_form';
import json_form_data from './datalayer_form_attr.json';
let self;
let page_path;
let datalayer_form_attr = {};
let trigger_datalayer_form = false;
let counter_interactions = 0;
let first_interaction = [];
let observer = null;
let observer2 = null;
let get_datalayer;
let user_email;
let options_service;

export class DataLayer_events_form {
  constructor() {
    self = this;
    page_path = window.location.href; // Get the current url
    // bind events
    $(window).on('load', () => self.onLoad());
    // Location page brochure form first time and repeat
    $(document).on('click','.btn_wrapper .gtm-informatiepakket, #brochure_aanvragen_button, #brochure_aanvragen_clone', e => self.serviceBrochureLocationStep0(e));
    $(document).on('input','.modal.brochure_aanvragen form input',e => self.serviceBrochureLocationStep1(e));
    // Location results page and location page contact form
    $(document).on('click','.list-item__btn.contact_aanvragen_button',e => self.contactSearchStep0(e));
    $(document).on('click', '.vestigingspagina_coordinator_contact .contact_aanvragen_button', () => self.contactStep0('contact-location'));
    $(document).on('click', '.service_aanvragen_button', () => self.contactStep0('service-signup-location'));
    $(document).on('input', '.modal.contact_aanvragen input', e => self.contactStep1(e, null));
    // Component nieuwsbrief
    $(document).on('input', '#form1004 input', e => self.formAsideFirstInteraction(e));
    $(document).on('submit', '#form1004',e => self.storeUserEmail(e, '#field1023'));

    // bind Gravity forms submission
    document.addEventListener('gform/theme/scripts_loaded', () => {
      gform.utils.addAsyncFilter('gform/submission/pre_submission', async (data) => {
        const formId = data.form.dataset.formid;
        const formElement = $('#gform_' + formId);
        if ( formElement.closest('.modal').hasClass('contact_page_show') ) {
          // Contact button form
          self.storeUserEmail(formElement, '.ginput_container_email input');
          self.contactStep2(null, 'contact-button');
        } else if ( formElement.closest('.modal').hasClass('brochure_aanvragen') ) {
          // Brochure form
          self.storeOptionsService(formElement, 'select');
          self.storeUserEmail(formElement, '.ginput_container_email input');
          self.serviceBrochureLocationStep2(formElement);
        } else if ( ( formElement.closest('.modal').hasClass('contact_aanvragen') )
                || ( formElement.closest('.modal').hasClass('service-signup-location') ) ) {
          // Contact location form
          self.storeOptionsService(formElement, 'select');
          self.storeUserEmail(formElement, '.ginput_container_email input');
          self.contactStep2(formElement, null);
        } else if ( formElement.parents('.prijsmodule-form-contact').length ) {
          // Prijsmodule contact form
          self.storeOptionsServiceInput(formElement, '.gekozen_dienst_field input');
          self.storeUserEmail(formElement, 'input[type=email]');
          self.prijsmoduleStep2();
        } else if ( ( formElement.parents('.text-with-form').length ) && ( $('body').hasClass('page-template-landingspage-lokatie') ) ) {
          // Location request form
          self.storeOptionsService(formElement, 'select');
          self.storeUserEmail(formElement, '.ginput_container_email input');
          self.requestLocationStep2(formElement);
        } else if ( ( formElement.parents('.text-with-form').length ) && ( $('body').hasClass('page-template-search-list-ext') ) ) {
          //Ext results form
          self.extResultsStep2();
        }
        return data;
      });
    });
  }

  onLoad(){
    datalayer_form_attr.page_path = page_path;
    self.isPageForm(); // Check if the page is full form or if it has a form based on the URL
    self.isFormBedank(); // Check if the page is a "thank you" page coming from a form
    // Push a new datalayer when the page is a visible form
    if ( trigger_datalayer_form ) {
      trigger_datalayer_form = false;
      new DataLayer_form( datalayer_form_attr );
    }
    self.isFormOnLoad(); // Check if the page contains a form based on the selector

    // Online bijles
    $('.bl-front-search .bl-search-choice input').on('change', () => self.homeOBLStep0());
    $('.bl-front-search .select-level div').on('click', () => self.homeOBLStep1());
    // First interaction
    const inputSelectors = [
      '.intakeform__wrapper .c-intake-form input', // Component "Content, Intakeformulier (Skoleo)"
      '#gform_81 input', // /webinar-deelname/
      '.consultation_free_week_HWB input', // /meelopen/
      'body.page-template-search-list-ext .text-with-form input', // /examentraining/aanmelden/
      '#vacancy-order-form input', // /werken-bij-lyceo/aanmelden/
      '.vestigingspagina .text-with-form form', // vestigingspagina
    ].join(', ');
    $(inputSelectors).on('input', e => self.formAsideFirstInteraction(e));
    $('#gform_10 input').on('input', () => self.formTrackingStep1()); // /contact/formulier/
    $('#js-information-form #profile_voornaam').on('input', () => self.brochureRequestStep1());
    $('#hwb-order-form #to-step-2, #bl-order-form #to-step-2').on('click',() => self.serviceSignUpLocationStep1());
    $('#gform_170 input').on('input',() => self.serviceSignUpLocationStep1()); // /online-bijles/formulier-online-bijles/
    // Store user email
    $('.c-intake-form form').on('submit', e => self.storeUserEmail(e, 'input[name="email"]'));
    const formSelectors = [
      '#gform_81',
      '.consultation_free_week_HWB',
      '#gform_170', // /online-bijles/formulier-online-bijles/
      '#gform_10', // /contact/formulier/
      'body.page-template-search-list-ext .text-with-form form',
    ].join(', ');
    $(formSelectors).on('submit', e => self.storeUserEmail(e, '.ginput_container_email input'));
    $('#vacancy-order-form').on('submit', e => {
      self.storeUserEmail(e, '#email');
    });
    $('#js-information-form').on('submit', e => self.storeUserEmail(e, '#profile_email'));
    // Contact button form
    $('.contact_options_mail[data-dismiss="modal"]').on('click',() => self.contactStep0('contact-button'));
    $('.contact_page_show input').on('input', () => self.contactStep1( null,'contact-button'));
    // Prijsmodule vragen form
    $('.prijsmodule-form-vragen input').on('change',() => self.prijsmoduleStep1('prijsmodule-vragen'));
    $('.prijsmodule-form-vragen input[type=submit]').on('click', () => self.prijsmoduleVragenStep2());
    // Prijsmodule contact form
    $('.prijsmodule-results-item-link').on('click',() => self.prijsmoduleStep0('prijsmodule-contact'));
    $('.prijsmodule-form-contact input').on('input',() => self.prijsmoduleStep1('prijsmodule-contact'));
  }

  homeOBLStep0() {
    if ($('.bl-search-choice input[name=colorRadio]:checked').val() === 'Online') {
      self.homeTabsOnlineBijles();
      datalayer_form_attr.step_name = 'your_request';
      datalayer_form_attr.step = '0';
      new DataLayer_form( datalayer_form_attr );
    }
  }

  homeOBLStep1() {
    self.homeTabsOnlineBijles();
    datalayer_form_attr.step_name = 'add_information';
    datalayer_form_attr.step = '1';
    if ( !first_interaction.includes('homeOBL') ) {
      new DataLayer_form( datalayer_form_attr );
      window.localStorage.setItem('form_event_key', datalayer_form_attr.event);
    }
    first_interaction.push('homeOBL');
  }

  formTrackingStep1() {
    self.formFullFirstInteraction();
    if ( trigger_datalayer_form ) {
      trigger_datalayer_form = false;
      new DataLayer_form( datalayer_form_attr );
    }
  }

  brochureRequestStep1() {
    self.formFullFirstInteraction();
    if ( trigger_datalayer_form ) {
      trigger_datalayer_form = false;
      datalayer_form_attr.form_variant = 'brochure_request';
      new DataLayer_form( datalayer_form_attr );
    }
  }

  serviceSignUpLocationStep1() {
    self.formFullFirstInteraction();
    if ( trigger_datalayer_form ) {
      trigger_datalayer_form = false;
      new DataLayer_form( datalayer_form_attr );
      user_email = $('#profile_email').val();
      window.localStorage.setItem('user_email_key', user_email);
    }
  }

  contactStep0(form) {
    self.isContactForm(form);
    datalayer_form_attr.step_name = 'visible';
    datalayer_form_attr.step = '0';
    new DataLayer_form( datalayer_form_attr );
    first_interaction = first_interaction.filter(function(item) {
      return item !== 'contact';
    });
  }

  contactStep1(e, form) {
    if ( !first_interaction.includes('contact') ) {
      if (e) {
        const current_selector = $(e.currentTarget);
        if ($(e.currentTarget).parents('.contact_aanvragen').hasClass('service-signup-location')) {
          self.isContactForm('service-signup-location');
        } else if (current_selector.parents('.page-template-landingspage-lokatie').length) {
          self.isContactForm('contact-location');
        } else {
          self.isContactFormSearch('contact-location', current_selector, 1);
        }
      } else if (form) {
        self.isContactForm(form);
      }
      datalayer_form_attr.step_name = 'first_interaction';
      datalayer_form_attr.step = '1';
      new DataLayer_form( datalayer_form_attr );
    }
  first_interaction.push('contact');
  }

  contactStep2(e, form) {
    let current_selector = null;
    let serviceSignupLocation = false;

    if (e) {
      current_selector = e instanceof jQuery ? e : $(e.currentTarget);
      if (current_selector.parents('.contact_aanvragen').hasClass('service-signup-location')) {
        serviceSignupLocation = true;
      }
    }

    observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        $(mutation.addedNodes).each((_, node) => {
          if ($(node).is('.gform_confirmation_message') || $(node).find('.gform_confirmation_message').length) {
            // Disconnect observer when the message is detected
            observer.disconnect();
            if (e) {
              const current_selector = e instanceof jQuery ? e : $(e.currentTarget);
              if (serviceSignupLocation) {
                self.isContactForm('service-signup-location');
              } else if ($('body').hasClass('page-template-landingspage-lokatie')) {
                self.isContactForm('contact-location');
              } else {
                self.isContactFormSearch('contact-location', current_selector, 2);
              }
              datalayer_form_attr.options = {};
              datalayer_form_attr.options.service = window.localStorage.getItem('options_service_key');
            } else if (form) {
              self.isContactForm(form);
            }
            datalayer_form_attr.user_email = window.localStorage.getItem('user_email_key');
            datalayer_form_attr.step_name = 'complete';
            datalayer_form_attr.step = '2';
            new DataLayer_form(datalayer_form_attr);
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  serviceBrochureLocationStep0(e) {
    if ($(e.currentTarget).hasClass('gtm-informatiepakket')) {
      self.isContactForm('service-brochure-location');
    } else {
      self.isContactForm('brochure-location');
    }
    datalayer_form_attr.step_name = 'visible';
    datalayer_form_attr.step = '0';
    new DataLayer_form( datalayer_form_attr );
  }

  serviceBrochureLocationStep1(e) {
    if ( !first_interaction.includes('serviceBrochureLocation') ) {
      if ($(e.currentTarget).parents('.brochure_aanvragen').hasClass('service-brochure-location')) {
        self.isContactForm('service-brochure-location');
      } else {
        self.isContactForm('brochure-location');
      }
      datalayer_form_attr.step_name = 'first_interaction';
      datalayer_form_attr.step = '1';
      new DataLayer_form( datalayer_form_attr );
    }
    first_interaction.push('serviceBrochureLocation');
  }

  serviceBrochureLocationStep2(e) {
    const modalContainer = document.querySelector('.modal.brochure_aanvragen');
    if (observer) {
      return;
    }
    observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        $(mutation.addedNodes).each((_, node) => {
            if ($(node).is('.gform_confirmation_message') || $(node).find('.gform_confirmation_message').length) {
              // Disconnect observer when the message is detected
              observer.disconnect();
              const target = e instanceof jQuery ? e : $(e.currentTarget);
              if (target.parents('.brochure_aanvragen').hasClass('service-brochure-location')) {
                self.isContactForm('service-brochure-location');
              } else {
                self.isContactForm('brochure-location');
              }
              datalayer_form_attr.step_name = 'complete';
              datalayer_form_attr.step = '2';
              datalayer_form_attr.options = {};
              datalayer_form_attr.options.service = window.localStorage.getItem('options_service_key');
              datalayer_form_attr.user_email = window.localStorage.getItem('user_email_key');
              new DataLayer_form(datalayer_form_attr);
            }
        });
      });
    });

    observer.observe(modalContainer, {
      childList: true,
      subtree: true,
    });
  }

  requestLocationStep2() {
    const formContainer = document.querySelector('.vestigingspagina .text-with-form');
    if (observer2) {
      return;
    }
    observer2 = new MutationObserver((mutations2) => {
      mutations2.forEach((mutation) => {
        $(mutation.addedNodes).each((_, node) => {
          if ($(node).is('.gform_confirmation_message') || $(node).find('.gform_confirmation_message').length) {
            // Disconnect observer when the message is detected
            observer2.disconnect();
            datalayer_form_attr.step_name = 'complete';
            datalayer_form_attr.step = '2';
            datalayer_form_attr.options = {};
            datalayer_form_attr.options.service = window.localStorage.getItem('options_service_key');
            datalayer_form_attr.user_email = window.localStorage.getItem('user_email_key');
            new DataLayer_form(datalayer_form_attr);
          }
        });
      });
    });

    observer2.observe(formContainer, {
      childList: true,
      subtree: true,
    });

  }

  contactSearchStep0(e) {
    const current_selector = $(e.currentTarget);
    self.isContactFormSearch('contact-location', current_selector, 0);
    datalayer_form_attr.step_name = 'visible';
    datalayer_form_attr.step = '0';
    new DataLayer_form( datalayer_form_attr );
  }

  prijsmoduleStep0(form) {
    self.isPrijsmoduleForm(form);
    datalayer_form_attr.step_name = 'visible';
    datalayer_form_attr.step = '0';
    datalayer_form_attr.options = {};
    datalayer_form_attr.options.service = $('.prijsmodule-form-contact-form .gekozen_dienst_field input').val();
    new DataLayer_form( datalayer_form_attr );
    first_interaction = first_interaction.filter(function(item) {
      return item !== 'prijsmodule';
    });
  }

  prijsmoduleStep1(form) {
    if ( !first_interaction.includes('prijsmodule') ) {
      self.isPrijsmoduleForm(form);
      datalayer_form_attr.step_name = 'first_interaction';
      datalayer_form_attr.step = '1';
      new DataLayer_form( datalayer_form_attr );
    }
    first_interaction.push('prijsmodule');
  }

  prijsmoduleVragenStep2() {
    self.isPrijsmoduleForm('prijsmodule-vragen');
    datalayer_form_attr.step_name = 'complete';
    datalayer_form_attr.step = '2';
    new DataLayer_form( datalayer_form_attr );
    first_interaction = first_interaction.filter(function(item) {
      return item !== 'prijsmodule';
    });
  }

  prijsmoduleStep2() {
    const formContainer = document.querySelector('.prijsmodule-form-contact-form');

    observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        $(mutation.addedNodes).each((_, node) => {
          if ($(node).is('.gform_confirmation_message') || $(node).find('.gform_confirmation_message').length) {
            self.isPrijsmoduleForm('prijsmodule-contact');
            datalayer_form_attr.step_name = 'complete';
            datalayer_form_attr.step = '2';
            datalayer_form_attr.options = {};
            datalayer_form_attr.options.service = window.localStorage.getItem('options_service_key');
            datalayer_form_attr.user_email = window.localStorage.getItem('user_email_key');
            new DataLayer_form(datalayer_form_attr);
          }
        });
      });
    });

    observer.observe(formContainer, {
      childList: true,
      subtree: true,
    });
  }

  extResultsStep2() {
    const formContainer = document.querySelector('.text-with-form');

    observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        $(mutation.addedNodes).each((_, node) => {
            if ($(node).is('.gform_confirmation_message') || $(node).find('.gform_confirmation_message').length) {
              datalayer_form_attr.event = 'request_form_EXT';
              datalayer_form_attr.form_id = 'examentraining';
              datalayer_form_attr.form_type = 'aside';
              datalayer_form_attr.form_variant = 'consultation';
              datalayer_form_attr.step_name = 'thank_you';
              datalayer_form_attr.step = '2';
              datalayer_form_attr.user_email = window.localStorage.getItem('user_email_key');
              new DataLayer_form( datalayer_form_attr );
            }
        });
      });
    });

    observer.observe(formContainer, {
      childList: true,
      subtree: true,
    });
  }

  // Define the standard variables for the contact form datalayer
  isContactForm(form) {
    datalayer_form_attr.form_type = 'pop_up';
    datalayer_form_attr.form_variant = 'contact_info';
    if (form === 'contact-location') {
      datalayer_form_attr.event = 'form_contact_location';
      datalayer_form_attr.form_id = 'contact-form-location';
      datalayer_form_attr.service_location = $('meta[itemprop="name"]').attr('content');
    } else if ((form === 'brochure-location') || (form === 'service-brochure-location')) {
      datalayer_form_attr.event = (form === 'brochure-location') ? 'brochure_request_location' : 'service_brochure_request_location' ;
      datalayer_form_attr.form_id = 'brochure-form-location';
      datalayer_form_attr.form_variant = 'brochure_request';
      datalayer_form_attr.service_location = $('meta[itemprop="name"]').attr('content');
    } else if (form === 'contact-button') {
      datalayer_form_attr.event = 'advice_popup_message';
      datalayer_form_attr.form_id = 'contact-form';
      datalayer_form_attr.form_name = 'Mail ons met je vraag';
    } else if (form === 'service-signup-location') {
      datalayer_form_attr.event = 'service_sign_up_location';
      datalayer_form_attr.form_id = 'contact-form';
      datalayer_form_attr.form_name = 'Meld je aan';
    } else {
      datalayer_form_attr.event = 'form_tracking';
    }
  }

  // Define the standard variables for the contact form datalayer on search results page
  isContactFormSearch(form, current_selector, step) {
    let product;
    let service_location;
    if (step === 0) {
      if ( page_path.indexOf('/vestigingen/') >= 0 ) {
        product = 'all';
      } else {
        product = current_selector.parents('[data-module="searchBijles"]').attr('data-product');
      }
      const parent_li = current_selector.closest('li');
      service_location = parent_li.find('meta[itemprop="name"]').attr('content');
      window.localStorage.setItem('contact_product', product);
      window.localStorage.setItem('service_location', service_location);
    } else {
      product = window.localStorage.getItem('contact_product');
      service_location = window.localStorage.getItem('service_location');
    }
    datalayer_form_attr.event = 'direct_contact_location_overview';
    datalayer_form_attr.form_id = 'contact-form-location';
    datalayer_form_attr.form_name = 'contact form - search ' + product;
    datalayer_form_attr.service_location = service_location;
    datalayer_form_attr.form_type = 'pop_up';
    datalayer_form_attr.form_variant = 'contact_info';
  }

  // Define the standard variables for the online bijles (homepage) form datalayer
  homeTabsOnlineBijles() {
    datalayer_form_attr.event = 'HOME_consultation_request_OBL';
    datalayer_form_attr.form_type = 'full_page';
    datalayer_form_attr.form_name = 'Online Bijles - tutoring information';
    datalayer_form_attr.form_id = 'online-bijles';
    datalayer_form_attr.form_variant = 'registration';
  }

  // Define the standard variables for the contact form datalayer
  isPrijsmoduleForm(form) {
    if (form === 'prijsmodule-vragen') {
      datalayer_form_attr.event = 'pricing_module_tracking';
      datalayer_form_attr.form_id = 'gform_178';
      datalayer_form_attr.form_variant = 'pricing';
    } else {
      datalayer_form_attr.event = 'form_tracking_pricing_module';
      datalayer_form_attr.form_id = 'gform_179';
      datalayer_form_attr.form_variant = 'contact_info_pricing_module';
    }
    get_datalayer = dataLayer.find(function(obj){
      return obj.event==='data_ready';
    });
    datalayer_form_attr.service_location = get_datalayer.page.page_title;
    datalayer_form_attr.form_type = 'full_page';
  }

  // Check if the page is full form or if it has a visible form on load
  isPageForm() {
    const full_form_pages = [ // Array of pages with full form
      '/formulier-huiswerkbegeleiding/?addproduct=',
      '/formulier-bijles/?addproduct=',
      '/online-bijles/formulier-online-bijles/',
      '/informatiepakket-aanvragen/',
      '/contact/formulier/',
    ];
    // store attr in the array if the current page is on the list
    if ( self.isCurrentPage( full_form_pages ) ) {
      trigger_datalayer_form = true;
      datalayer_form_attr.form_type = 'full_page';
      datalayer_form_attr.step = '0';
    }
    if ( page_path.indexOf( '/informatiepakket-aanvragen/' ) >= 0 ) {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      const paramDienst = urlParams.get('dienst');
      const paramOrigin = urlParams.get('origin');
      if ( paramDienst === 'bijles') {
        datalayer_form_attr.event = (paramOrigin === 'menu') ? 'menu_brochure_request_BL': 'brochure_request_BL';
      } else if ( paramDienst === 'huiswerkbegeleiding') {
        datalayer_form_attr.event = (paramOrigin === 'menu') ? 'menu_brochure_request_HWB': 'brochure_request_HWB';
      } else if ( paramDienst === 'examentraining') {
        datalayer_form_attr.event = (paramOrigin === 'menu') ? 'menu_brochure_request_EXT': 'brochure_request_EXT';
      } else if ( paramDienst === 'bijles_online') {
        datalayer_form_attr.event = 'brochure_request_OBL';
      } else if ( paramDienst === 'basisschoolbegeleiding') {
        datalayer_form_attr.event = 'brochure_request_BBS';
      } else if ( paramDienst === 'examenjaar') {
        datalayer_form_attr.event = 'brochure_request_EXT_YR';
      } else if ( paramDienst === 'codelab') {
        datalayer_form_attr.event = 'brochure_request_Codelab';
      } else {
        datalayer_form_attr.event = 'brochure_request_general';
      }
      datalayer_form_attr.form_variant = 'brochure_request';
    } else if ( page_path.indexOf( '/online-bijles/formulier-online-bijles/' ) >= 0 ) {
      datalayer_form_attr.event = 'sign_up_OBL';
      datalayer_form_attr.form_variant = 'sign-up';
    } else if ( page_path.indexOf( '/formulier-' ) >= 0 ) {
      datalayer_form_attr.event = 'service_sign_up_location';
      datalayer_form_attr.form_variant = 'sign-up';
    } else if ( page_path.indexOf( '/contact/formulier/' ) >= 0 ) {
      datalayer_form_attr.event = 'general_contact_form';
      datalayer_form_attr.form_variant = 'contact_info';
      datalayer_form_attr.form_id = 'contact-form';
      datalayer_form_attr.step_name = 'visible';
    }
    if (datalayer_form_attr.event) {
      window.localStorage.setItem('form_event_key', datalayer_form_attr.event);
    }
    counter_interactions = 0;
  }

  // Check if there is a visible form from the list and store attr in the array
  isFormOnLoad(){
    datalayer_form_attr.form_type = 'aside';
    datalayer_form_attr.step_name = 'visible';
    datalayer_form_attr.step = '0';

    if ( $('#gform_81').length ){
      datalayer_form_attr.event = 'form_tracking';
      new DataLayer_form( datalayer_form_attr );
    }
    if ( $('app-form-intake[type="bijles"]').length ) {
      // other value for www.lyceo.nl/huiswerkbegeleiding-en-bijles/ (page-id-141226)
      datalayer_form_attr.event = ($('body').hasClass('page-id-141226')) ? 'LP_consultation_request_O_BL' : 'consultation_request_BL' ;
      new DataLayer_form( datalayer_form_attr );
    }
    if ( $('app-form-intake[type="huiswerkbegeleiding"]').length ) {
      // other value for www.lyceo.nl/huiswerkbegeleiding-en-bijles/ (page-id-141226)
      datalayer_form_attr.event = ($('body').hasClass('page-id-141226')) ? 'LP_consultation_request_HWB' : 'consultation_request_HWB' ;
      new DataLayer_form( datalayer_form_attr );
    }
    if ( $('app-form-intake[type="bijles_online"]').length ) {
      datalayer_form_attr.event = 'consultation_request_OBL';
      new DataLayer_form( datalayer_form_attr );
    }
    if ( $('app-form-intake[type="examenjaar"]').length ) {
      datalayer_form_attr.event = 'consultation_request_EXT_YR';
      new DataLayer_form( datalayer_form_attr );
    }
    if ( $('app-form-intake[type="codelab"]').length ) {
      datalayer_form_attr.event = 'consultation_request_Codelab';
      new DataLayer_form( datalayer_form_attr );
    }
    if ( $('app-form-intake[type="intensieve_toetsweek"]').length ) {
      datalayer_form_attr.event = 'sign_up_TWOK';
      datalayer_form_attr.form_variant = 'sign_up';
      new DataLayer_form( datalayer_form_attr );
    }
    if ( $('.consultation_free_week_HWB').length ) {
      datalayer_form_attr.event = 'consultation_free_week_HWB';
      datalayer_form_attr.form_id = 'meeloopweek';
      datalayer_form_attr.form_variant = 'consultation';
      const service_location = page_path.split('/meelopen/');
      datalayer_form_attr.service_location = service_location[1].replace('/','');
      window.localStorage.setItem('service_location_key', datalayer_form_attr.service_location);
      new DataLayer_form( datalayer_form_attr );
    }
    if ( $('.component-3').length ) {
      datalayer_form_attr.event = 'newsletter_sign_up';
      datalayer_form_attr.form_id = 'newsletter';
      datalayer_form_attr.form_variant = 'sign_up';
      new DataLayer_form( datalayer_form_attr );
    }
    if ( $('.prijsmodule-form-vragen').length ) {
      self.prijsmoduleStep0('prijsmodule-vragen');
    }
    if ( $('body.page-template-search-list-ext .text-with-form form').length ){
      datalayer_form_attr.event = 'request_form_EXT';
      new DataLayer_form( datalayer_form_attr );
    }
    if ( $('.vestigingspagina .text-with-form').length ) {
      datalayer_form_attr.event = 'location_form_request';
      datalayer_form_attr.form_variant = 'sign_up';
      datalayer_form_attr.service_location = $('meta[itemprop="name"]').attr('content');
      window.localStorage.setItem('service_location_key', datalayer_form_attr.service_location);
      new DataLayer_form( datalayer_form_attr );
    }
    const vacancyForm = $('#vacancy-order-form');
    if ( vacancyForm.length ) {
      datalayer_form_attr.event = 'job_application_request';
      datalayer_form_attr.form_id = 'vacancy-order-form';
      datalayer_form_attr.form_variant = 'registration';
      datalayer_form_attr.options = {};
      datalayer_form_attr.options.service = vacancyForm.attr('data-service');
      window.localStorage.setItem('options_service_key', datalayer_form_attr.options.service);
      new DataLayer_form( datalayer_form_attr );
    }
  }

  // Check if the user input is the first interaction in a full form
  formFullFirstInteraction(){
    if ( counter_interactions === 0 ) {
      trigger_datalayer_form = true;
      datalayer_form_attr.event = window.localStorage.getItem('form_event_key') ?? 'form_tracking';
      datalayer_form_attr.form_type = 'full_page';
      datalayer_form_attr.step = '1';
    }
    counter_interactions++;
  }

  formAsideFirstInteraction(e) {
    datalayer_form_attr.form_type = 'aside';
    datalayer_form_attr.step_name = 'first_interaction';
    datalayer_form_attr.step = '1';
    const current_element = $(e.currentTarget);
    if ( ( current_element.closest('#gform_81').length )
        && ( !first_interaction.includes('form_tracking') ) ) {
      datalayer_form_attr.event = 'form_tracking';
      new DataLayer_form( datalayer_form_attr );
      first_interaction.push('form_tracking');
    }
    if ( ( current_element.closest('app-form-intake[type="bijles"]').length )
      && ( !first_interaction.includes('consultation_request_BL') ) ) {
      // other value for www.lyceo.nl/huiswerkbegeleiding-en-bijles/ (page-id-141226)
      datalayer_form_attr.event = ($('body').hasClass('page-id-141226')) ? 'LP_consultation_request_O_BL' : 'consultation_request_BL' ;
      new DataLayer_form( datalayer_form_attr );
      first_interaction.push('consultation_request_BL');
    }
    if ( ( current_element.closest('app-form-intake[type="huiswerkbegeleiding"]').length )
      && ( !first_interaction.includes('consultation_request_HWB') ) ) {
      // other value for www.lyceo.nl/huiswerkbegeleiding-en-bijles/ (page-id-141226)
      datalayer_form_attr.event = ($('body').hasClass('page-id-141226')) ? 'LP_consultation_request_HWB' : 'consultation_request_HWB' ;
      new DataLayer_form( datalayer_form_attr );
      first_interaction.push('consultation_request_HWB');
    }
    if ( ( current_element.closest('app-form-intake[type="bijles_online"]').length )
      && ( !first_interaction.includes('consultation_request_OBL') ) ) {
      datalayer_form_attr.event = 'consultation_request_OBL';
      new DataLayer_form( datalayer_form_attr );
      first_interaction.push('consultation_request_OBL');
    }
    if ( ( current_element.closest('app-form-intake[type="examenjaar"]').length )
      && ( !first_interaction.includes('consultation_request_EXT_YR') ) ) {
      datalayer_form_attr.event = 'consultation_request_EXT_YR';
      new DataLayer_form( datalayer_form_attr );
      first_interaction.push('consultation_request_EXT_YR');
    }
    if ( ( current_element.closest('app-form-intake[type="codelab"]').length )
      && ( !first_interaction.includes('consultation_request_Codelab') ) ) {
      datalayer_form_attr.event = 'consultation_request_Codelab';
      new DataLayer_form( datalayer_form_attr );
      first_interaction.push('consultation_request_Codelab');
    }
    if ( ( current_element.closest('app-form-intake[type="intensieve_toetsweek"]').length )
      && ( !first_interaction.includes('sign_up_TWOK') ) ) {
      datalayer_form_attr.event = 'sign_up_TWOK';
      datalayer_form_attr.form_variant = 'sign_up';
      new DataLayer_form( datalayer_form_attr );
      first_interaction.push('sign_up_TWOK');
    }
    if ( (current_element.closest('.consultation_free_week_HWB').length )
      && ( !first_interaction.includes('consultation_free_week_HWB') ) ) {
      datalayer_form_attr.event = 'consultation_free_week_HWB';
      datalayer_form_attr.form_id = 'meeloopweek';
      datalayer_form_attr.form_variant = 'consultation';
      datalayer_form_attr.service_location = window.localStorage.getItem('service_location_key');
      new DataLayer_form( datalayer_form_attr );
      first_interaction.push('consultation_free_week_HWB');
    }
    if ( ( current_element.closest('.component-3').length )
      && ( !first_interaction.includes('newsletter_sign_up') ) ) {
      datalayer_form_attr.event = 'newsletter_sign_up';
      datalayer_form_attr.form_id = 'newsletter';
      datalayer_form_attr.form_variant = 'sign_up';
      new DataLayer_form( datalayer_form_attr );
      first_interaction.push('newsletter_sign_up');
    }
    if ( ( current_element.closest('.text-with-form').length )
      && ( current_element.parents('.page-template-search-list-ext').length )
      && ( !first_interaction.includes('request_form_EXT') ) ) {
      datalayer_form_attr.event = 'request_form_EXT';
      datalayer_form_attr.service_location = window.localStorage.getItem('service_location_key')
      new DataLayer_form( datalayer_form_attr );
      first_interaction.push('request_form_EXT');
    }
    if ( ( current_element.closest('.text-with-form').length )
      && ( current_element.parents('.vestigingspagina').length )
      && ( !first_interaction.includes('location_form_request') ) ) {
      datalayer_form_attr.event = 'location_form_request';
      datalayer_form_attr.form_variant = 'sign_up';
      datalayer_form_attr.service_location = window.localStorage.getItem('service_location_key')
      new DataLayer_form( datalayer_form_attr );
      first_interaction.push('location_form_request');
    }
    if ( ( current_element.closest('#vacancy-order-form').length )
      && ( !first_interaction.includes('job_application_request') ) ) {
      datalayer_form_attr.event = 'job_application_request';
      datalayer_form_attr.form_id = 'vacancy-order-form';
      datalayer_form_attr.form_variant = 'registration';
      datalayer_form_attr.options.service = window.localStorage.getItem('options_service_key');
      new DataLayer_form( datalayer_form_attr );
      first_interaction.push('job_application_request');
    }
    if (datalayer_form_attr.event) {
      window.localStorage.setItem('form_event_key', datalayer_form_attr.event);
    }
  }

  // Check if the page is a "thank you" page coming from a form
  isFormBedank() {
    const bedank_pages = [ // Array of "thank you" pages of forms
      '/bedankpagina-vrijblijvend-intakegesprek-bijles/',
      '/bedankpagina-vrijblijvend-intakegesprek-online-bijles/',
      '/bedankpagina-vrijblijvend-intakegesprek-huiswerkbegeleiding/',
      '/bedankpagina-vrijblijvend-intakegesprek-het-lyceo-examenjaar/',
      '/bedankpagina-contactaanvraag-codelab/',
      '/bedankpagina-aanvraag-huiswerkbegeleiding/',
      '/bedankpagina-aanvraag-bijles/',
      '/bedankpagina-aanvraag-online-bijles/',
      '/bedankpagina-aanvraag-twok/',
      '/bedankpagina-aanvraag-informatiepakket/',
      '/bedankpagina-informatiepakket-',
      '/bedankpagina-werken-bij/',
      '/bedankpagina-aanmelden-studiecoaching/',
      '/bedankpagina-meelopen-huiswerkbegeleiding',
      '/nieuwsbriefbedankt/',
      '/contact/formulier/?',
    ];
    // store attr in the array if the current page is on the list or is an exception
    if ( ( self.isCurrentPage( bedank_pages ) ) || ( $('.gform_confirmation_message').length )) {
      trigger_datalayer_form = true;
      bedank_pages.push('/webinar-deelname/'); // add the exception page to the array
      const url_path = self.currentPageURL( bedank_pages ); // Return the url fragment of the current page
      const form_attr = self.getFormByURL(url_path); // Return data from the json file
      datalayer_form_attr.form_id = form_attr[0].form_id;
      if ( url_path === '/bedankpagina-aanvraag-online-bijles/') {
        datalayer_form_attr.form_name = form_attr[0].form_name;
      }
      if (( url_path === '/bedankpagina-aanvraag-huiswerkbegeleiding/')
        || ( url_path === '/bedankpagina-aanvraag-bijles/')
        || ( url_path === '/bedankpagina-aanvraag-informatiepakket/')
        || ( url_path === '/bedankpagina-informatiepakket-') ) {
        datalayer_form_attr.form_id = window.localStorage.getItem('form_id_key');
        datalayer_form_attr.service_location = window.localStorage.getItem('service_location_key');
      } else if (( url_path === '/bedankpagina-werken-bij/')) {
        datalayer_form_attr.options = {};
        datalayer_form_attr.options.service = window.localStorage.getItem('options_service_key');
      }
      if (( url_path === '/bedankpagina-aanvraag-huiswerkbegeleiding/')
        || ( url_path === '/bedankpagina-aanvraag-bijles/')
        || ( url_path === '/bedankpagina-meelopen-huiswerkbegeleiding')) {
        datalayer_form_attr.service_location = window.localStorage.getItem('service_location_key');
      }
      datalayer_form_attr.event = window.localStorage.getItem('form_event_key') ?? 'form_tracking';
      datalayer_form_attr.form_type = form_attr[0].form_type;
      datalayer_form_attr.form_variant = form_attr[0].form_variant;
      datalayer_form_attr.user_email = window.localStorage.getItem('user_email_key');
      datalayer_form_attr.step_name = form_attr[0].step_name;
      datalayer_form_attr.step = '2';
    }
  }

  // Check if the selected page is the current page
  isCurrentPage( pages ) {
    for ( let i in pages ) {
      if ( page_path.indexOf( pages[i] ) >= 0 ) {
        return true;
      }
    }
    return false;
  }

  // Return the url fragment of the current page
  currentPageURL( pages ) {
    for ( let i in pages ) {
      if ( page_path.indexOf( pages[i] ) >= 0 ) {
        return pages[i];
      }
    }
  }

  // Return data from the json file
  getFormByURL(url) {
    return json_form_data.filter(
      function(data) {
        return data.url === url;
      }
    );
  }

  storeUserEmail(e, emailField) {
    const target = e instanceof jQuery ? e : $(e.currentTarget);
    user_email = target.find(emailField).val();
    window.localStorage.setItem('user_email_key', user_email);
  }

  storeOptionsService(e, serviceField) {
    const target = e instanceof jQuery ? e : $(e.currentTarget);
    options_service = target.find(serviceField + ' option:selected').text();
    window.localStorage.setItem('options_service_key', options_service.trim());
  }

  storeOptionsServiceInput(e, serviceField) {
    const target = e instanceof jQuery ? e : $(e.currentTarget);
    options_service = target.find(serviceField).val();
    window.localStorage.setItem('options_service_key', options_service.trim());
  }

}
